// defining defaultFontSize to equal value of lg means that the font size
// of html base element will be exactly 10px on lg viewport size
//
// xs, sm, md, lg, xl - screen sizes
export var DEFAULT_FONTS = {
  defaultFontSize: 16,
  // on which VP size we want 10px for html font-size
  xs: 10,
  sm: 12,
  md: 14,
  lg: 16,
  xl: 18
};
export var DEFAULT_BROWSER_FONT = 16;